import { render, staticRenderFns } from "./Replacement.vue?vue&type=template&id=339d2b4c"
import script from "./Replacement.vue?vue&type=script&lang=js"
export * from "./Replacement.vue?vue&type=script&lang=js"
import style0 from "./Replacement.vue?vue&type=style&index=0&id=339d2b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports